/**
 * Unsaved changes on the open page, for actions that change the account before they navigate.
 *
 * The router asks before a navigation drops a page's unsaved changes (useBlocker, see
 * InventoryItemPage). Switching role or company, choosing again on the entry page and logging
 * out change the signed-in state first, and that alone can swap the page out before any
 * navigation is asked about. Those actions go through whenLeaveAllowed, which asks the page first.
 */
type LeaveCheck = () => Promise<boolean>

let check: LeaveCheck | null = null

/** A page with unsaved changes registers how to ask; the function returned takes it off again. */
export function registerLeaveCheck(ask: LeaveCheck): () => void {
  check = ask
  return () => {
    if (check === ask) check = null
  }
}

/** Runs `action` at once when nothing is unsaved, otherwise once the page has agreed to let go. */
export function whenLeaveAllowed(action: () => void): void {
  if (!check) {
    action()
    return
  }
  void check().then((leave) => {
    if (leave) action()
  })
}
